// Same Trustpilot widget endpoint the PDP uses (snippets/product-stars.liquid)
const TRUSTPILOT_URL = "https://widget.trustpilot.com/trustbox-data/577258fb31f02306e4e3aaf9";
// Footer micro-star widget — business-unit summary (no SKU)
const BUSINESS_TRUSTPILOT_URL = "https://widget.trustpilot.com/trustbox-data/5406e65db0d04a09e042d5fc";
const BUSINESS_UNIT_ID = "62e2925efd3c2b72264b1d37";
const PRODUCT_TP_TEMPLATE = "5763bccae0a06d08e809ecbb";
// Grid widget for company (service) reviews — same as sections/bf-reviews.liquid
const BUSINESS_TP_TEMPLATE = "539adbd6dec7e10e686debee";
const BUSINESS_TP_TOKEN = "4683c0d6-9256-435f-9ef4-4ad9adaf4b60";

const STAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none"><path d="M7.64636 3.28082L10.9752 3.79295C11.2313 3.79295 11.2953 4.11303 11.1032 4.30508L8.67062 6.67367C8.6066 6.73769 8.54259 6.86572 8.6066 6.92974L9.18275 10.2586C9.18275 10.5146 8.9907 10.7067 8.73464 10.5787L5.72588 8.97825C5.66186 8.97825 5.53383 8.97825 5.46981 8.97825L2.46106 10.5146C2.26901 10.6427 2.01295 10.4506 2.01295 10.1946L2.58909 6.86572C2.58909 6.80171 2.58909 6.67367 2.52508 6.60966L0.0924678 4.24106C-0.0995804 4.04902 0.0284512 3.79295 0.284515 3.72893L3.61335 3.28082C3.67737 3.28082 3.8054 3.2168 3.8054 3.15279L5.34178 0.144036C5.46982 -0.048012 5.7899 -0.048012 5.85391 0.144036L7.32628 3.21681C7.32628 3.28082 7.45431 3.34484 7.51833 3.40885L7.64636 3.28082Z" fill="black"/></svg>`;
const STAR_SVG_WHITE = STAR_SVG.replace('fill="black"', 'fill="white"');

const buildTrustpilotWidgetSku = (handle: string, skus: string[]): string => {
  const variantSkus = skus.filter(Boolean);
  if (!handle) return variantSkus.join(",");
  return variantSkus.length ? `${handle}ALL,${variantSkus.join(",")}` : `${handle}ALL`;
};

const resolveTrustpilotSummarySkus = (container: HTMLElement, skus: string[]): string => {
  const fromDom = container.dataset.trustpilotSkus?.trim();
  if (fromDom) return fromDom;
  return skus.filter(Boolean).join(",");
};

type TrustpilotGlobal = {
  Trustpilot?: { loadFromElement?: (el: HTMLElement, refresh?: boolean) => void };
};

const loadTrustpilotWidget = (widget: HTMLElement, attempt = 0): void => {
  const trustpilot = (window as TrustpilotGlobal).Trustpilot;
  if (trustpilot?.loadFromElement) {
    try {
      trustpilot.loadFromElement(widget, true);
    } catch {
      // consent not given / TP script absent — drawer shows its built-in fallback link
    }
    return;
  }

  if (attempt < 40) {
    window.setTimeout(() => loadTrustpilotWidget(widget, attempt + 1), 100);
  }
};

const clearTpWidgetFrame = (widget: HTMLElement): void => {
  for (const iframe of widget.querySelectorAll("iframe")) {
    iframe.remove();
  }
};

const configureProductTpWidget = (widget: HTMLElement, handle: string, title: string, skus: string[]): void => {
  widget.dataset.templateId = PRODUCT_TP_TEMPLATE;
  widget.dataset.sku = buildTrustpilotWidgetSku(handle, skus);
  widget.dataset.name = title;
  delete widget.dataset.token;
  delete widget.dataset.stars;
};

const configureBusinessTpWidget = (widget: HTMLElement): void => {
  widget.dataset.templateId = BUSINESS_TP_TEMPLATE;
  widget.dataset.token = BUSINESS_TP_TOKEN;
  widget.dataset.stars = "5";
  delete widget.dataset.sku;
  delete widget.dataset.name;
};

const scheduleTrustpilotWidgetLoad = (widget: HTMLElement): void => {
  let loaded = false;
  const run = (): void => {
    if (loaded) return;
    loaded = true;
    loadTrustpilotWidget(widget);
  };

  // iOS Safari measures iframe height while the drawer is off-screen — init after slide-in.
  document.addEventListener("ek:tp-drawer-open", run, { once: true });
  window.setTimeout(run, 400);
};

const buildStar = (fillOpacity: string, white = false, sizePx?: number): HTMLElement => {
  const wrap = document.createElement("div");
  wrap.innerHTML = white ? STAR_SVG_WHITE : STAR_SVG;
  const svg = wrap.querySelector("svg");
  if (svg && sizePx) {
    svg.setAttribute("width", String(sizePx));
    svg.setAttribute("height", String(sizePx));
  }
  wrap.querySelector("path")?.setAttribute("fill-opacity", fillOpacity);
  return wrap;
};

let chevronFilterCounter = 0;

const buildChevronIcon = (): HTMLElement => {
  chevronFilterCounter += 1;
  const filterId = `berater-tp-chevron-filter-${chevronFilterCounter}`;
  const chevron = document.createElement("span");
  chevron.className = "inline-flex ml-1 shrink-0";
  chevron.innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g filter="url(#${filterId})"><path d="M8.59961 15.0996C12.7593 15.0996 16.0996 11.7593 16.0996 7.59961C16.0996 3.43995 12.7593 0.0996094 8.59961 0.0996094C4.43994 0.0996094 1.09961 3.43995 1.09961 7.59961C1.09961 11.7593 4.43994 15.0996 8.59961 15.0996Z" fill="white"/><path d="M8.59961 15.0996C12.7417 15.0996 16.0996 11.7417 16.0996 7.59961C16.0996 3.45748 12.7417 0.0996094 8.59961 0.0996094C4.45747 0.0996094 1.09961 3.45748 1.09961 7.59961C1.09961 11.7417 4.45747 15.0996 8.59961 15.0996Z" stroke="#F7F2EC" stroke-width="0.2"/><path d="M5.44824 6.46484L8.5995 9.55308L11.6877 6.46484" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><filter id="${filterId}" x="0" y="0" width="17.1992" height="17.1992" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_${chevronFilterCounter}"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_${chevronFilterCounter}" result="shape"/></filter></defs></svg>`;
  return chevron;
};

const buildStarRow = (rating: number, showChevron = false, white = false): HTMLElement => {
  const row = document.createElement("div");
  row.className = "flex flex-row items-center justify-center gap-0.5";

  const fullStars = Math.floor(rating);
  const partial = rating % 1;
  const emptyStars = 5 - Math.ceil(rating);
  const star = (opacity: string) => buildStar(opacity, white, 13);

  for (let i = 0; i < fullStars; i += 1) row.appendChild(star("1"));

  if (partial > 0) {
    const holder = document.createElement("div");
    holder.style.position = "relative";
    holder.style.display = "inline-block";
    const filled = document.createElement("div");
    filled.style.position = "absolute";
    filled.style.inset = "0";
    filled.style.overflow = "hidden";
    filled.style.width = `${partial * 100}%`;
    filled.appendChild(star("1"));
    holder.appendChild(filled);
    holder.appendChild(star("0.2"));
    row.appendChild(holder);
  }

  for (let i = 0; i < emptyStars; i += 1) row.appendChild(star("0.2"));

  const text = document.createElement("span");
  text.className = `text-xs font-body tracking-[0.12px] ml-1${white ? " text-white" : ""}`;
  text.textContent = rating.toFixed(1);
  row.appendChild(text);

  if (showChevron) {
    row.appendChild(buildChevronIcon());
  }

  return row;
};

/**
 * Opens the theme's global Trustpilot drawer (sections/ek-tpDrawer.liquid, rendered in
 * theme.liquid) for an arbitrary product — keeps the user inside the Berater funnel.
 * The widget element is re-targeted to the product's SKUs and re-initialized.
 */
export const openTrustpilotDrawer = (handle: string, title: string, skus: string[]): boolean => {
  const widget = document.querySelector<HTMLElement>("#tpContents .trustpilot-widget");
  const open = (window as { openTpDrawer?: () => void }).openTpDrawer;
  if (typeof open !== "function") return false;

  if (widget) {
    configureProductTpWidget(widget, handle, title, skus);
    clearTpWidgetFrame(widget);
  }

  open();

  if (widget) {
    scheduleTrustpilotWidgetLoad(widget);
  }

  return true;
};

/**
 * Opens the global Trustpilot drawer for company (service) reviews.
 */
export const openBusinessTrustpilotDrawer = (): boolean => {
  const widget = document.querySelector<HTMLElement>("#tpContents .trustpilot-widget");
  const open = (window as { openTpDrawer?: () => void }).openTpDrawer;
  if (typeof open !== "function") return false;

  if (widget) {
    configureBusinessTpWidget(widget);
    clearTpWidgetFrame(widget);
  }

  open();

  if (widget) {
    scheduleTrustpilotWidgetLoad(widget);
  }

  return true;
};

interface TrustpilotSummary {
  starsAverage: number;
  numberOfReviews?: { total?: number } | number;
}

/**
 * Fetches the Trustpilot product-review summary for the given SKUs and renders
 * a star row into the container. The container stays hidden when there are no
 * reviews (rating 0) or the request fails — never show unbacked stars.
 */
export const renderTrustpilotStars = async (container: HTMLElement, skus: string[], onClick: (() => void) | null): Promise<void> => {
  const skuParam = resolveTrustpilotSummarySkus(container, skus);
  if (!skuParam.replace(/,/g, "").trim()) return;

  try {
    const response = await fetch(`${TRUSTPILOT_URL}?businessUnitId=${BUSINESS_UNIT_ID}&locale=de-DE&sku=${skuParam}`, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) return;

    const data = (await response.json()) as { productReviewsSummary?: TrustpilotSummary };
    const rating = data.productReviewsSummary?.starsAverage ?? 0;
    if (!rating) return;

    container.innerHTML = "";
    if (onClick) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "inline-flex cursor-pointer";
      button.setAttribute("aria-label", "Bewertungen ansehen");
      button.appendChild(buildStarRow(rating, true));
      button.addEventListener("click", onClick);
      container.appendChild(button);
    } else {
      container.appendChild(buildStarRow(rating));
    }
    container.classList.remove("hidden");
    container.classList.add("flex");
  } catch {
    // leave hidden
  }
};

interface BusinessTrustpilotSummary {
  trustScore?: number;
  stars?: number;
}

/**
 * Fetches Ehrenkind's company Trustpilot score and renders intro stars
 * (same row layout as the result card: stars, rating, chevron).
 */
export const renderBusinessTrustpilotStars = async (
  container: HTMLElement,
  onClick: (() => void) | null,
  white = false,
): Promise<void> => {
  try {
    const response = await fetch(`${BUSINESS_TRUSTPILOT_URL}?businessUnitId=${BUSINESS_UNIT_ID}&locale=de-DE`, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) return;

    const data = (await response.json()) as { businessUnit?: BusinessTrustpilotSummary };
    const rating = data.businessUnit?.trustScore ?? data.businessUnit?.stars ?? 0;
    if (!rating) return;

    container.innerHTML = "";
    container.setAttribute("aria-hidden", "false");

    const row = buildStarRow(rating, Boolean(onClick), white);

    if (onClick) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "inline-flex cursor-pointer";
      button.setAttribute("aria-label", "Trustpilot-Bewertungen ansehen");
      button.appendChild(row);
      button.addEventListener("click", onClick);
      container.appendChild(button);
    } else {
      container.appendChild(row);
    }

    container.classList.remove("hidden");
  } catch {
    // leave hidden
  }
};
